export function SelectedIcon({ className = "" }: { className?: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M14.6654 6.5L8.2487 12.9167L5.33203 10" stroke="white" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "SelectedIcon";
